import React from 'react'
import { connect } from 'react-redux'

import { fromContext } from 'store/selectors'
import { showCookiesBanner } from 'store/actions'
import CookiesBanner from './CookiesBanner'

const CookiesBannerContainer = props => <CookiesBanner {...props} />

export default connect(
  state => ({
    cookiesBannerIsOpen: fromContext.cookiesBannerIsOpen(state),
    context: fromContext.getPathContext(state),
    locale: fromContext.getLocale(state),
  }),
  { showCookiesBanner },
)(CookiesBannerContainer)
